/**
 * 將 Byte 轉換為易讀單位
 * @param bytes 原始位元組數值
 * @returns String
 */

import numeral from 'numeral';

const formatBytes = (bytes: number): string => {
  const format: string = '0.00b';

  if (bytes === 0) {
    return '0 Bytes';
  }
  return numeral(bytes).format(format).toUpperCase();
};

export default formatBytes;
